export default "__VITE_ASSET__DeQWyvdy__"